module.exports = __webpack_public_path__ + "static/media/033.864a1e2a.jpg";